import React, { FC } from 'react';
import { Box } from '@mui/material';
import ActivateUser from '../components/LoginScreenComponents/ActivateUser';
// import CompanyLogin from '../components/LoginScreenComponents/CompanyLogin';

const Activate: FC = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <ActivateUser />
        </Box>
      </Box>
    </Box>
  );
};

export default Activate;
